// extracted by mini-css-extract-plugin
export var genericContainer = "latest-articles-module--genericContainer--265d9";
export var gridContainer = "latest-articles-module--gridContainer--d7523";
export var gridStaticContainer = "latest-articles-module--gridStaticContainer--3e8cb";
export var itemContainer = "latest-articles-module--itemContainer--59a7e";
export var itemDescription = "latest-articles-module--itemDescription--3a4df";
export var itemImg = "latest-articles-module--itemImg--691c1";
export var itemTitle = "latest-articles-module--itemTitle--8c853";
export var latestContainer = "latest-articles-module--latestContainer--f0ce5";
export var listContainer = "latest-articles-module--listContainer--a0189";
export var title = "latest-articles-module--title--67345";
export var titleContainer = "latest-articles-module--titleContainer--ce6e6";
export var underline = "latest-articles-module--underline--e507b";